/* ============================================================
   Bliss Forte AU -- Main Theme JavaScript v2
   GSAP animations, cart drawer, sticky ATC, pixels, CRO
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* -- Skip to main content link ------------------------------------ */
  const skipLink = document.createElement('a');
  skipLink.href = '#main-content';
  skipLink.className = 'skip-to-main';
  skipLink.textContent = 'Skip to main content';
  document.body.insertBefore(skipLink, document.body.firstChild);

  /* -- Header scroll effect ----------------------------------------- */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* -- Mobile nav ---------------------------------------------------- */
  const navToggle = document.getElementById('nav-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('open');
      navToggle.classList.toggle('open', isOpen);
      navToggle.setAttribute('aria-expanded', String(isOpen));
      mobileNav.setAttribute('aria-hidden', String(!isOpen));
      if (isOpen) {
        // Focus trap: focus first link
        const firstLink = mobileNav.querySelector('a');
        if (firstLink) firstLink.focus();
      }
    });
    mobileNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        mobileNav.classList.remove('open');
        navToggle.classList.remove('open');
        navToggle.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
      });
    });
    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileNav.classList.contains('open')) {
        mobileNav.classList.remove('open');
        navToggle.classList.remove('open');
        navToggle.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
        navToggle.focus();
      }
    });
  }

  /* -- Desktop dropdown keyboard nav --------------------------------- */
  document.querySelectorAll('.nav-link--dropdown').forEach(trigger => {
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        trigger.closest('.nav-has-dropdown')?.querySelector('.nav-dropdown')?.classList.toggle('open', !expanded);
      }
      if (e.key === 'Escape') {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.closest('.nav-has-dropdown')?.querySelector('.nav-dropdown')?.classList.remove('open');
      }
    });
  });

  /* ====================================================
     CART DRAWER
     ================================================== */
  let cartDrawerEl = document.getElementById('bf-cart-drawer');
  let cartOverlayEl = document.getElementById('bf-cart-overlay');

  // Inject drawer HTML if not present
  if (!cartDrawerEl) {
    const drawerHTML = `
      <div id="bf-cart-overlay" class="cart-drawer-overlay" aria-hidden="true"></div>
      <div id="bf-cart-drawer" class="cart-drawer" role="dialog" aria-label="Cart" aria-hidden="true">
        <div class="cart-drawer__header">
          <h2 class="cart-drawer__title">Your Cart</h2>
          <button id="bf-cart-close" class="cart-drawer__close" aria-label="Close cart">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div id="bf-cart-items" class="cart-drawer__items"></div>
        <div class="cart-drawer__footer">
          <div id="bf-shipping-bar" class="shipping-bar"></div>
          <div class="cart-drawer__totals">
            <span>Subtotal</span>
            <span id="bf-cart-subtotal">A$0.00</span>
          </div>
          <a href="/checkout" id="bf-checkout-btn" class="btn btn--primary cart-drawer__checkout">
            Checkout <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-left:6px;vertical-align:middle"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </a>
          <a href="/cart" class="cart-drawer__view-full">View Full Cart</a>
        </div>
      </div>`;
    document.body.insertAdjacentHTML('beforeend', drawerHTML);
    cartDrawerEl = document.getElementById('bf-cart-drawer');
    cartOverlayEl = document.getElementById('bf-cart-overlay');
  }

  function openCartDrawer() {
    cartDrawerEl.setAttribute('aria-hidden', 'false');
    cartDrawerEl.classList.add('open');
    cartOverlayEl.classList.add('open');
    cartOverlayEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    refreshCartDrawer();
    // Fire begin_checkout pixel events when cart opens
    fireBeginCheckout();
  }

  function closeCartDrawer() {
    cartDrawerEl.setAttribute('aria-hidden', 'true');
    cartDrawerEl.classList.remove('open');
    cartOverlayEl.classList.remove('open');
    cartOverlayEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  document.getElementById('bf-cart-close')?.addEventListener('click', closeCartDrawer);
  cartOverlayEl?.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && cartDrawerEl?.classList.contains('open')) closeCartDrawer();
  });

  // Cart toggle button
  document.getElementById('cart-toggle')?.addEventListener('click', (e) => {
    e.preventDefault();
    openCartDrawer();
  });

  function formatMoney(cents) {
    return 'A$' + (cents / 100).toFixed(2);
  }

  function renderShippingBar(total) {
    const bar = document.getElementById('bf-shipping-bar');
    if (!bar) return;
    const threshold = 7500; // $75 AUD in cents
    if (total >= threshold) {
      bar.innerHTML = `<div class="shipping-bar__text">You qualify for free shipping!</div>
        <div class="shipping-bar__track"><div class="shipping-bar__fill" style="width:100%"></div></div>`;
    } else {
      const remaining = ((threshold - total) / 100).toFixed(2);
      const pct = Math.min((total / threshold) * 100, 100);
      bar.innerHTML = `<div class="shipping-bar__text">Add <strong>A$${remaining}</strong> more for free shipping</div>
        <div class="shipping-bar__track"><div class="shipping-bar__fill" style="width:${pct}%"></div></div>`;
    }
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const itemsEl = document.getElementById('bf-cart-items');
        const subtotalEl = document.getElementById('bf-cart-subtotal');
        const countEl = document.getElementById('cart-count');

        if (countEl) countEl.textContent = cart.item_count > 0 ? cart.item_count : '';

        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        renderShippingBar(cart.total_price);

        if (!itemsEl) return;
        if (cart.item_count === 0) {
          itemsEl.innerHTML = `<div class="cart-drawer__empty">
            <div style="font-size:2.5rem;margin-bottom:12px;"></div>
            <p>Your cart is empty</p>
            <a href="/collections/all" class="btn btn--primary btn--sm" style="margin-top:16px;">Shop Now</a>
          </div>`;
          return;
        }
        itemsEl.innerHTML = cart.items.map(item => `
          <div class="cart-drawer__item" data-key="${item.key}">
            <a href="${item.url}">
              <img src="${item.image}" alt="${item.product_title}" width="72" height="72" loading="lazy">
            </a>
            <div class="cart-drawer__item-body">
              <a href="${item.url}" class="cart-drawer__item-name">${item.product_title}</a>
              ${item.variant_title !== 'Default Title' ? `<div class="cart-drawer__item-variant">${item.variant_title}</div>` : ''}
              <div class="cart-drawer__item-controls">
                <div class="qty-control">
                  <button type="button" class="qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">-</button>
                  <span class="qty-value">${item.quantity}</span>
                  <button type="button" class="qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
                </div>
                <button type="button" class="cart-drawer__remove" data-key="${item.key}" aria-label="Remove ${item.product_title}">Remove</button>
              </div>
            </div>
            <div class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</div>
          </div>`).join('');

        // Bind qty and remove buttons
        itemsEl.querySelectorAll('.qty-btn').forEach(btn => {
          btn.addEventListener('click', () => {
            const qty = parseInt(btn.dataset.qty, 10);
            if (qty < 0) return;
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: btn.dataset.key, quantity: qty })
            }).then(() => refreshCartDrawer());
          });
        });
        itemsEl.querySelectorAll('.cart-drawer__remove').forEach(btn => {
          btn.addEventListener('click', () => {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
            }).then(() => refreshCartDrawer());
          });
        });

        // Checkout button fires begin_checkout pixels
        document.getElementById('bf-checkout-btn')?.addEventListener('click', fireBeginCheckout, { once: true });
      })
      .catch(() => {});
  }

  // Initial cart count
  refreshCartDrawer();

  /* -- Begin Checkout pixel events ----------------------------------- */
  let checkoutFired = false;
  function fireBeginCheckout() {
    if (checkoutFired) return;
    checkoutFired = true;
    fetch('/cart.js').then(r => r.json()).then(cart => {
      const value = cart.total_price / 100;
      const items = cart.items.map(i => ({ item_name: i.product_title, price: i.price / 100, quantity: i.quantity }));
      if (typeof gtag !== 'undefined') {
        gtag('event', 'begin_checkout', { currency: 'AUD', value, items });
      }
      if (typeof ttq !== 'undefined') {
        ttq.track('InitiateCheckout', { value, currency: 'AUD', content_type: 'product' });
      }
      if (typeof pintrk !== 'undefined') {
        pintrk('track', 'checkout', { value, currency: 'AUD', order_quantity: cart.item_count });
      }
      if (typeof snaptr !== 'undefined') {
        snaptr('track', 'START_CHECKOUT', { price: value, currency: 'AUD', number_items: cart.item_count });
      }
    }).catch(() => {});
  }

  // Also fire when clicking /checkout link anywhere
  document.querySelectorAll('a[href="/checkout"]').forEach(el => {
    el.addEventListener('click', fireBeginCheckout);
  });

  /* -- Accordion / FAQ ----------------------------------------------- */
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const body = trigger.nextElementSibling;
      const isOpen = body.classList.contains('open');
      document.querySelectorAll('.accordion-body').forEach(b => b.classList.remove('open'));
      document.querySelectorAll('.accordion-trigger').forEach(t => { t.classList.remove('open'); t.setAttribute('aria-expanded', 'false'); });
      if (!isOpen) {
        body.classList.add('open');
        trigger.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
    trigger.setAttribute('aria-expanded', 'false');
  });

  /* -- Product Gallery Thumbnails ------------------------------------ */
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mainImg = document.getElementById('product-main-img');
      if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
      thumb.closest('.product-gallery__thumbs')?.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  /* -- Product Tabs -------------------------------------------------- */
  document.querySelectorAll('.product-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;
      const container = tab.closest('.product-tabs-container');
      if (!container) return;
      container.querySelectorAll('.product-tab').forEach(t => { t.classList.remove('active'); t.setAttribute('aria-selected', 'false'); });
      container.querySelectorAll('.product-tab-content').forEach(c => c.classList.remove('active'));
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      container.querySelector(`[data-tab-content="${target}"]`)?.classList.add('active');
    });
  });

  /* -- Variant select sync ------------------------------------------- */
  const variantSelect = document.getElementById('variant-select');
  const addBtn = document.querySelector('.add-to-cart-btn');
  if (variantSelect && addBtn) {
    variantSelect.addEventListener('change', () => {
      addBtn.dataset.variantId = variantSelect.value;
    });
  }

  /* -- Sticky ATC bar (product pages) -------------------------------- */
  const stickyBar = document.getElementById('sticky-atc-bar');
  const mainAtcBtn = document.querySelector('.add-to-cart-btn');
  if (stickyBar && mainAtcBtn) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        stickyBar.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '-80px 0px 0px 0px' });
    observer.observe(mainAtcBtn);

    stickyBar.querySelector('.sticky-atc-btn')?.addEventListener('click', () => {
      mainAtcBtn.click();
    });
  }

  /* -- Add to Cart (JS fetch + pixels + drawer open) ----------------- */
  function handleATC(btn) {
    const variantId = btn.dataset.variantId;
    const productTitle = btn.dataset.productTitle || '';
    const price = parseFloat(btn.dataset.price || '0');
    if (!variantId) return;

    const origHTML = btn.innerHTML;
    btn.innerHTML = '<span class="btn-spinner"></span> Adding...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      btn.innerHTML = '&#10003; Added!';
      btn.style.background = '#059669';

      // Fire all ATC pixels
      if (typeof gtag !== 'undefined') {
        gtag('event', 'add_to_cart', { currency: 'AUD', value: price, items: [{ item_name: productTitle, price, quantity: 1 }] });
      }
      if (typeof ttq !== 'undefined') {
        ttq.track('AddToCart', { content_name: productTitle, currency: 'AUD', value: price });
      }
      if (typeof pintrk !== 'undefined') {
        pintrk('track', 'addtocart', { value: price, currency: 'AUD' });
      }
      if (typeof snaptr !== 'undefined') {
        snaptr('track', 'ADD_CART', { price, currency: 'AUD' });
      }
      if (typeof klaviyo !== 'undefined') {
        klaviyo.push(['track', 'Added to Cart', { 'Product Name': productTitle, 'Price': price }]);
      }

      // Open cart drawer
      setTimeout(() => {
        openCartDrawer();
        btn.innerHTML = origHTML;
        btn.style.background = '';
        btn.disabled = false;
      }, 600);
    })
    .catch(() => {
      btn.innerHTML = origHTML;
      btn.style.background = '';
      btn.disabled = false;
      window.location.href = `/cart/${variantId}:1`;
    });
  }

  document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
    btn.addEventListener('click', () => handleATC(btn));
  });

  // Also handle product-card native form ATCs  intercept POST and open drawer
  document.querySelectorAll('.product-card__atc-form').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const variantId = form.querySelector('input[name="id"]')?.value;
      const productName = form.closest('.product-card')?.querySelector('.product-card__name')?.textContent?.trim() || '';
      const priceText = form.closest('.product-card')?.querySelector('.price-current')?.textContent?.replace(/[^0-9.]/g, '') || '0';
      if (!variantId) return;

      const btn = form.querySelector('button');
      const origText = btn?.textContent;
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        if (btn) { btn.textContent = 'Added!'; btn.style.background = '#059669'; }
        if (typeof gtag !== 'undefined') {
          gtag('event', 'add_to_cart', { currency: 'AUD', value: parseFloat(priceText), items: [{ item_name: productName, price: parseFloat(priceText), quantity: 1 }] });
        }
        if (typeof ttq !== 'undefined') ttq.track('AddToCart', { content_name: productName, currency: 'AUD', value: parseFloat(priceText) });
        if (typeof pintrk !== 'undefined') pintrk('track', 'addtocart', { value: parseFloat(priceText), currency: 'AUD' });
        if (typeof snaptr !== 'undefined') snaptr('track', 'ADD_CART', { price: parseFloat(priceText), currency: 'AUD' });
        if (typeof klaviyo !== 'undefined') klaviyo.push(['track', 'Added to Cart', { 'Product Name': productName, 'Price': parseFloat(priceText) }]);
        setTimeout(() => {
          openCartDrawer();
          if (btn) { btn.textContent = origText; btn.style.background = ''; btn.disabled = false; }
        }, 600);
      })
      .catch(() => { if (btn) { btn.textContent = origText; btn.disabled = false; } });
    });
  });

  /* -- GSAP Scroll Animations ---------------------------------------- */
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    const heroTl = gsap.timeline({ delay: 0.3 });
    ['hero__eyebrow','hero__title','hero__sub','hero__ctas'].forEach((cls, i) => {
      const el = document.querySelector('.' + cls);
      if (el) heroTl.to(el, { opacity: 1, y: 0, duration: 0.7 + i*0.1, ease: 'power2.out' }, i === 0 ? undefined : '-=0.4');
    });
    const floatWrap = document.querySelector('.hero__float-wrap');
    if (floatWrap) gsap.fromTo(floatWrap, { opacity: 0, x: 60, scale: 0.9 }, { opacity: 1, x: 0, scale: 1, duration: 1.2, delay: 0.6, ease: 'power2.out' });

    gsap.utils.toArray('.reveal').forEach(el => {
      gsap.fromTo(el, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out', scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' } });
    });
    gsap.utils.toArray('.reveal-left').forEach(el => {
      gsap.fromTo(el, { opacity: 0, x: -40 }, { opacity: 1, x: 0, duration: 0.8, ease: 'power2.out', scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' } });
    });
    gsap.utils.toArray('.reveal-right').forEach(el => {
      gsap.fromTo(el, { opacity: 0, x: 40 }, { opacity: 1, x: 0, duration: 0.8, ease: 'power2.out', scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' } });
    });
    gsap.utils.toArray('.stagger-parent').forEach(parent => {
      gsap.fromTo(parent.querySelectorAll('.stagger-child'), { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.6, stagger: 0.12, ease: 'power2.out', scrollTrigger: { trigger: parent, start: 'top 82%', toggleActions: 'play none none none' } });
    });
    gsap.utils.toArray('.parallax-img').forEach(img => {
      gsap.to(img, { yPercent: -20, ease: 'none', scrollTrigger: { trigger: img, start: 'top bottom', end: 'bottom top', scrub: 1 } });
    });
    document.querySelectorAll('.stat-number[data-count]').forEach(el => {
      const target = parseFloat(el.dataset.count), suffix = el.dataset.suffix || '';
      ScrollTrigger.create({ trigger: el, start: 'top 85%', once: true, onEnter: () => {
        gsap.fromTo({ val: 0 }, { val: target, duration: 2, ease: 'power2.out', onUpdate: function() { el.textContent = Math.round(this.targets()[0].val).toLocaleString() + suffix; } });
      }});
    });
  } else {
    const obs = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); }), { threshold: 0.12 });
    document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => obs.observe(el));
  }

  /* -- 3D Brand Render Carousel -------------------------------------- */
  const carousel = document.querySelector('.brand-carousel');
  if (carousel) {
    const cards = carousel.querySelectorAll('.brand-carousel__card');
    let active = 1;
    const total = cards.length;
    function layoutCarousel() {
      const offsets = [-480,-240,0,240,480], scales = [0.72,0.85,1,0.85,0.72];
      const zIndexes = [1,2,4,2,1], opacities = [0.5,0.8,1,0.8,0.5];
      cards.forEach((card, i) => {
        const pos = (i - active + total) % total, mapped = pos < 3 ? pos : pos - total, idx = mapped + 2;
        if (idx < 0 || idx >= offsets.length) { card.style.opacity = '0'; card.style.pointerEvents = 'none'; return; }
        card.style.opacity = opacities[idx]; card.style.zIndex = zIndexes[idx];
        card.style.pointerEvents = idx === 2 ? 'auto' : 'none';
        card.style.transform = `translateX(${offsets[idx]}px) scale(${scales[idx]})`;
      });
    }
    layoutCarousel();
    let autoRotate = setInterval(() => { active = (active + 1) % total; layoutCarousel(); }, 3500);
    cards.forEach((card, i) => {
      card.addEventListener('click', () => { clearInterval(autoRotate); active = i; layoutCarousel(); autoRotate = setInterval(() => { active = (active + 1) % total; layoutCarousel(); }, 3500); });
    });
  }

  /* -- Skin Quiz Logic ----------------------------------------------- */
  const quizContainer = document.querySelector('.quiz-container');
  if (quizContainer) {
    const steps = quizContainer.querySelectorAll('.quiz-step');
    const progressFill = quizContainer.querySelector('.quiz-progress-fill');
    let currentStep = 0;
    const answers = {};

    function showStep(n) {
      steps.forEach((s, i) => s.classList.toggle('active', i === n));
      if (progressFill) progressFill.style.width = `${(n / (steps.length - 1)) * 100}%`;
    }

    quizContainer.querySelectorAll('.quiz-option').forEach(option => {
      option.addEventListener('click', () => {
        const step = option.closest('.quiz-step');
        const key = step?.dataset.key || `q${currentStep}`;
        answers[key] = option.dataset.value;
        step?.querySelectorAll('.quiz-option').forEach(o => o.classList.remove('selected'));
        option.classList.add('selected');
        setTimeout(() => {
          if (currentStep < steps.length - 1) { currentStep++; showStep(currentStep); }
          else showQuizResult();
        }, 400);
      });
    });

    quizContainer.querySelectorAll('.quiz-back').forEach(btn => {
      btn.addEventListener('click', () => { if (currentStep > 0) { currentStep--; showStep(currentStep); } });
    });

    function showQuizResult() {
      const concern = answers.concern || '';
      let recs = [];
      if (concern === 'hydration') recs = ['hyaluronic-acid-serum','luxe-glow-moisturiser','hydrating-gel-mask'];
      else if (concern === 'blemish') recs = ['brightening-enzyme-cleanser','anti-blemish-toning-mist','hyaluronic-acid-serum'];
      else if (concern === 'brightening') recs = ['brightening-enzyme-cleanser','cream-exfoliant','hyaluronic-acid-serum'];
      else recs = ['brightening-enzyme-cleanser','hyaluronic-acid-serum','luxe-glow-moisturiser'];

      const resultEl = quizContainer.querySelector('.quiz-result');
      if (resultEl) {
        resultEl.innerHTML = buildQuizResult(recs);
        steps.forEach(s => s.classList.remove('active'));
        resultEl.classList.add('active');
        if (progressFill) progressFill.style.width = '100%';
        const email = answers.email;
        if (email && typeof klaviyo !== 'undefined') klaviyo.push(['identify', { $email: email }]);
      }
    }
    showStep(0);
  }

  function buildQuizResult(productIds) {
    const products = {
      'hyaluronic-acid-serum': { name: 'Hyaluronic Acid Serum', price: '$34.99', img: 'https://cdn.shopify.com/s/files/1/0927/5821/2894/files/hero-hyaluronic-acid-serum.jpg?v=1781391819', handle: 'hyaluronic-acid-serum' },
      'luxe-glow-moisturiser': { name: 'Luxe Glow Moisturiser', price: '$28.95', img: 'https://cdn.shopify.com/s/files/1/0927/5821/2894/files/hero-luxe-glow-moisturiser.jpg?v=1781391833', handle: 'luxe-glow-nourishing-moisturiser' },
      'hydrating-gel-mask': { name: 'Radiant Bloom Gel Mask', price: '$29.95', img: 'https://cdn.shopify.com/s/files/1/0927/5821/2894/files/hero-radiant-bloom-gel-mask.jpg?v=1781391858', handle: 'hydrating-gel-mask' },
      'brightening-enzyme-cleanser': { name: 'Brightening Enzyme Cleanser', price: '$32.95', img: 'https://cdn.shopify.com/s/files/1/0927/5821/2894/files/hero-brightening-enzyme-cleanser.jpg?v=1781391826', handle: 'brightening-enzyme-cleanse' },
      'anti-blemish-toning-mist': { name: 'Anti-Blemish Toning Mist', price: '$32.95', img: 'https://cdn.shopify.com/s/files/1/0927/5821/2894/files/hero-anti-blemish-toning-mist.jpg?v=1781391840', handle: 'anti-blemish-toning-mist' },
      'cream-exfoliant': { name: 'Glow-Boosting Cream Exfoliant', price: '$31.95', img: 'https://cdn.shopify.com/s/files/1/0927/5821/2894/files/hero-cream-exfoliant.jpg?v=1781391848', handle: 'cream-exfoliant' },
    };
    return `<div class="quiz-result-inner">
      <h2 class="quiz-result__title">Your Personalised Routine</h2>
      <p class="quiz-result__sub">Based on your answers, we recommend these products for your skin.</p>
      <div class="quiz-result-grid">
        ${productIds.map(id => {
          const p = products[id]; if (!p) return '';
          return `<div class="quiz-result-card">
            <img src="${p.img}" alt="${p.name}" loading="lazy">
            <div class="quiz-result-card__body">
              <div class="quiz-result-card__name">${p.name}</div>
              <div class="quiz-result-card__price">${p.price}</div>
              <a href="/products/${p.handle}" class="btn btn--primary btn--sm">Shop Now</a>
            </div></div>`;
        }).join('')}
      </div>
      <a href="/collections/all" class="btn btn--outline" style="margin-top:24px;">View All Products</a>
    </div>`;
  }

  /* -- Exit Intent (Klaviyo popup) ----------------------------------- */
  let exitIntentFired = false;
  document.addEventListener('mouseleave', (e) => {
    if (e.clientY > 0 || exitIntentFired) return;
    exitIntentFired = true;
    if (typeof klaviyo !== 'undefined') {
      // Trigger Klaviyo popup form  uses embedded form WzCHTJ or any Klaviyo signup form
      // This fires the standard Klaviyo exit intent by simulating popup show
      klaviyo.push(['openForm', 'WzCHTJ']);
    }
  });

  /* -- Pinterest ViewContent fix (use correct event) ----------------- */
  /* -- Klaviyo Viewed Product --------------------------------------- */
  if (window.__bf_product) {
    const p = window.__bf_product;
    if (typeof gtag !== 'undefined') {
      gtag('event', 'view_item', { currency: 'AUD', value: p.price, items: [{ item_name: p.title, price: p.price, currency: 'AUD' }] });
    }
    if (typeof ttq !== 'undefined') ttq.track('ViewContent', { content_name: p.title, currency: 'AUD', value: p.price });
    if (typeof pintrk !== 'undefined') pintrk('track', 'ViewContent', { value: p.price, currency: 'AUD' });
    if (typeof snaptr !== 'undefined') snaptr('track', 'VIEW_CONTENT', { price: p.price, currency: 'AUD' });
    if (typeof klaviyo !== 'undefined') {
      klaviyo.push(['track', 'Viewed Product', {
        'ProductName': p.title,
        'ProductID': p.id,
        'Price': p.price,
        'URL': window.location.href
      }]);
      klaviyo.push(['identify', window.__bf_customer_email ? { $email: window.__bf_customer_email } : {}]);
    }
  }

  /* -- Klaviyo identify on all pages --------------------------------- */
  if (typeof klaviyo !== 'undefined' && window.__bf_customer_email) {
    klaviyo.push(['identify', { $email: window.__bf_customer_email }]);
  }

  /* -- Contact form -------------------------------------------------- */
  const contactForm = document.getElementById('contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = contactForm.querySelector('button[type="submit"]');
      const origText = btn?.textContent;
      if (btn) { btn.textContent = 'Sending...'; btn.disabled = true; }
      try {
        await fetch('/contact', { method: 'POST', body: new FormData(contactForm) });
        contactForm.innerHTML = '<div class="contact-success"><h3>Thank you!</h3><p>We will get back to you within 24 hours.</p></div>';
      } catch { if (btn) { btn.textContent = origText; btn.disabled = false; } }
    });
  }

});

/* 
   WAVE 3  Final Audit Improvements
   (Search Panel, Wishlist, Recently Viewed, Lightbox, Countdown)
    */

(function() {
  'use strict';

  /*  1. Header Search Panel Toggle  */
  const searchToggleBtn = document.getElementById('search-toggle');
  const searchPanel = document.getElementById('header-search-panel');
  const searchClose = document.getElementById('search-close');
  const searchInput = document.getElementById('header-search-input');

  if (searchToggleBtn && searchPanel) {
    searchToggleBtn.addEventListener('click', () => {
      const isOpen = searchPanel.classList.toggle('open');
      searchPanel.setAttribute('aria-hidden', String(!isOpen));
      searchToggleBtn.setAttribute('aria-expanded', String(isOpen));
      if (isOpen && searchInput) searchInput.focus();
    });
    searchClose?.addEventListener('click', () => {
      searchPanel.classList.remove('open');
      searchPanel.setAttribute('aria-hidden', 'true');
      searchToggleBtn.setAttribute('aria-expanded', 'false');
      searchToggleBtn.focus();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchPanel.classList.contains('open')) {
        searchPanel.classList.remove('open');
        searchPanel.setAttribute('aria-hidden', 'true');
        searchToggleBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /*  2. Wishlist (localStorage)  */
  const WISHLIST_KEY = 'bf_wishlist';
  function getWishlist() { try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch { return []; } }
  function saveWishlist(list) { try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch {} }

  function updateWishlistCount() {
    const list = getWishlist();
    const countEl = document.getElementById('wishlist-count');
    if (countEl) {
      const count = list.length;
      countEl.textContent = count;
      countEl.style.display = count > 0 ? 'flex' : 'none';
    }
    const headerWishlistBtn = document.getElementById('header-wishlist-btn');
    if (headerWishlistBtn) {
      const count = list.length;
      headerWishlistBtn.setAttribute('aria-label', `Wishlist (${count} item${count !== 1 ? 's' : ''})`);
    }
  }

  function initWishlistButtons() {
    const list = getWishlist();
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const id = btn.dataset.productId;
      if (list.some(p => String(p.id) === String(id))) {
        btn.classList.add('wishlisted');
        btn.setAttribute('aria-label', btn.dataset.productTitle + '  Remove from wishlist');
      }
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const wl = getWishlist();
        const productId = String(btn.dataset.productId);
        const idx = wl.findIndex(p => String(p.id) === productId);
        if (idx >= 0) {
          wl.splice(idx, 1);
          btn.classList.remove('wishlisted');
          btn.setAttribute('aria-label', btn.dataset.productTitle + '  Add to wishlist');
          showToast('Removed from wishlist');
        } else {
          wl.push({
            id: productId,
            handle: btn.dataset.productHandle,
            title: btn.dataset.productTitle,
            img: btn.dataset.productImg,
            price: btn.dataset.productPrice,
            url: btn.dataset.productUrl
          });
          btn.classList.add('wishlisted');
          btn.setAttribute('aria-label', btn.dataset.productTitle + '  Remove from wishlist');
          showToast('Added to wishlist ');
        }
        saveWishlist(wl);
        updateWishlistCount();
      });
    });
  }

  function renderWishlistPage() {
    const pageWishlistGrid = document.getElementById('wishlist-page-grid');
    if (!pageWishlistGrid) return;
    const list = getWishlist();
    if (list.length === 0) {
      pageWishlistGrid.innerHTML = '<div style="text-align:center;padding:60px 20px;"><p style="color:var(--text-muted);margin-bottom:24px;">Your wishlist is empty.</p><a href="/collections/all" class="btn btn--primary">Shop Now</a></div>';
      return;
    }
    pageWishlistGrid.innerHTML = list.map(p => `
      <div class="product-card" style="position:relative;">
        <div class="product-card__img-wrap">
          <a href="${p.url}"><img src="${p.img}" alt="${p.title}" loading="lazy" style="width:100%;aspect-ratio:1;object-fit:cover;border-radius:var(--radius);"></a>
        </div>
        <div class="product-card__body">
          <a href="${p.url}"><h3 class="product-card__name">${p.title}</h3></a>
          <div class="product-card__price"><span class="price-current">A$${p.price}</span></div>
        </div>
        <div class="product-card__actions">
          <a href="${p.url}" class="btn btn--primary">Shop Now</a>
          <button class="btn btn--outline wishlist-remove-btn" data-product-id="${p.id}" style="min-width:0;padding:10px 14px;" aria-label="Remove from wishlist">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>
          </button>
        </div>
      </div>
    `).join('');
    pageWishlistGrid.querySelectorAll('.wishlist-remove-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const wl = getWishlist().filter(p => String(p.id) !== String(btn.dataset.productId));
        saveWishlist(wl);
        updateWishlistCount();
        renderWishlistPage();
      });
    });
  }

  initWishlistButtons();
  updateWishlistCount();
  renderWishlistPage();

  /*  3. Recently Viewed Products (localStorage)  */
  const RV_KEY = 'bf_recently_viewed';
  const MAX_RV = 4;

  function pushRecentlyViewed() {
    const p = window.__bf_product;
    if (!p) return;
    try {
      let rv = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      rv = rv.filter(item => item.handle !== p.handle);
      const mainImg = document.getElementById('product-main-img');
      rv.unshift({
        handle: p.handle,
        title: p.title,
        price: p.price,
        url: window.location.pathname,
        img: mainImg ? mainImg.src : ''
      });
      if (rv.length > MAX_RV) rv = rv.slice(0, MAX_RV);
      localStorage.setItem(RV_KEY, JSON.stringify(rv));
    } catch {}
  }

  function renderRecentlyViewed() {
    const section = document.getElementById('recently-viewed-section');
    const grid = document.getElementById('recently-viewed-grid');
    if (!section || !grid) return;
    try {
      const rv = JSON.parse(localStorage.getItem(RV_KEY) || '[]')
        .filter(item => item.handle !== (window.__bf_product && window.__bf_product.handle));
      if (rv.length === 0) return;
      section.style.display = '';
      grid.innerHTML = rv.map(item => `
        <div class="product-card stagger-child">
          <div class="product-card__img-wrap">
            <a href="${item.url}" aria-label="${item.title}">
              <img src="${item.img}" alt="${item.title}" loading="lazy" style="width:100%;aspect-ratio:1;object-fit:cover;border-radius:var(--radius);">
            </a>
          </div>
          <div class="product-card__body">
            <a href="${item.url}"><h3 class="product-card__name">${item.title}</h3></a>
            <div class="product-card__price"><span class="price-current">A$${item.price}</span></div>
          </div>
          <div class="product-card__actions">
            <a href="${item.url}" class="btn btn--primary" style="width:100%;justify-content:center;">Shop Now</a>
          </div>
        </div>
      `).join('');
    } catch {}
  }

  if (window.__bf_product) {
    renderRecentlyViewed();
    setTimeout(pushRecentlyViewed, 3000); // push after 3s of dwell time
  }

  /*  4. Product Image Lightbox  */
  const lightbox = document.getElementById('product-lightbox');
  const lightboxImg = document.getElementById('product-lightbox-img');
  const lightboxClose = document.getElementById('product-lightbox-close');
  const lightboxBackdrop = document.getElementById('product-lightbox-backdrop');
  const zoomWrap = document.getElementById('product-gallery-zoom-wrap');
  const mainImg = document.getElementById('product-main-img');

  if (lightbox && zoomWrap && mainImg) {
    function openLightbox(src, alt) {
      lightboxImg.src = src.replace('800x800', '1600x1600');
      lightboxImg.alt = alt || '';
      lightbox.classList.add('open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      lightboxClose.focus();
    }
    function closeLightbox() {
      lightbox.classList.remove('open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    zoomWrap.addEventListener('click', () => openLightbox(mainImg.src, mainImg.alt));
    zoomWrap.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(mainImg.src, mainImg.alt); } });
    lightboxClose.addEventListener('click', closeLightbox);
    lightboxBackdrop.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && lightbox.classList.contains('open')) closeLightbox(); });
  }

  /*  5. Rotating Announcement Bar + Countdown (matches React AnnouncementBar)  */
  (function() {
    var msgs = document.querySelectorAll('.ann-msg');
    var countdownEl = document.getElementById('ann-countdown');
    var current = 0;
    var total = msgs.length;
    if (!total) return;

    // Countdown to midnight AEST
    function getSecsTilMidnight() {
      var now = new Date();
      var aest = new Date(now.toLocaleString('en-US', { timeZone: 'Australia/Sydney' }));
      var midnight = new Date(aest);
      midnight.setHours(24, 0, 0, 0);
      return Math.max(0, Math.floor((midnight.getTime() - aest.getTime()) / 1000));
    }
    var secs = getSecsTilMidnight();
    function fmtCd(s) {
      var h = String(Math.floor(s / 3600)).padStart(2, '0');
      var m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      var ss = String(s % 60).padStart(2, '0');
      return h + ':' + m + ':' + ss;
    }
    if (countdownEl) countdownEl.textContent = fmtCd(secs);
    setInterval(function() {
      secs = Math.max(0, secs - 1);
      if (countdownEl) countdownEl.textContent = fmtCd(secs);
    }, 1000);

    // Rotate every 4s with 300ms fade (matches React 4000ms interval + 300ms fade)
    function showMsg(idx) {
      msgs.forEach(function(el) {
        el.style.opacity = '0';
        el.style.display = 'none';
        el.classList.remove('ann-msg--active');
      });
      var el = msgs[idx];
      el.style.display = 'inline-flex';
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          el.style.opacity = '1';
          el.classList.add('ann-msg--active');
        });
      });
    }
    showMsg(0);
    setInterval(function() {
      var cur = msgs[current];
      cur.style.opacity = '0';
      cur.style.transition = 'opacity 0.3s ease';
      setTimeout(function() {
        cur.style.display = 'none';
        cur.classList.remove('ann-msg--active');
        current = (current + 1) % total;
        showMsg(current);
      }, 300);
    }, 4000);
  })()

  /*  6. Cart Page  No-Reload Qty Update  */
  const cartPageQtyBtns = document.querySelectorAll('.cart-page-qty-btn');
  cartPageQtyBtns.forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      const delta = parseInt(btn.dataset.delta || '0', 10);
      const qtyEl = btn.closest('.cart-item')?.querySelector('.cart-item__qty-display');
      const currentQty = parseInt(qtyEl?.textContent || '1', 10);
      const newQty = Math.max(0, currentQty + delta);
      btn.disabled = true;
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        });
        const cart = await res.json();
        // Update qty display inline
        if (qtyEl) qtyEl.textContent = newQty;
        // Update subtotal
        const subtotalEl = document.querySelector('.cart-subtotal-amount');
        if (subtotalEl) subtotalEl.textContent = 'A$' + (cart.total_price / 100).toFixed(2);
        // Update header cart count
        const headerCount = document.getElementById('cart-count');
        if (headerCount) headerCount.textContent = cart.item_count;
        // Remove row if qty 0
        if (newQty === 0) {
          btn.closest('.cart-item')?.remove();
          if (cart.item_count === 0) location.reload();
        }
        // Update free shipping progress
        if (typeof updateShippingProgress === 'function') updateShippingProgress(cart.total_price);
      } catch { location.reload(); }
      btn.disabled = false;
    });
  });

  /*  Toast utility (if not already defined)  */
  if (typeof window.showToast === 'undefined') {
    window.showToast = function(msg, duration = 3000) {
      let toast = document.getElementById('bf-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.id = 'bf-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        toast.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(16px);background:var(--green-deep);color:white;padding:12px 24px;border-radius:var(--radius-pill);font-size:0.875rem;font-weight:600;z-index:10000;opacity:0;transition:all 0.3s ease;pointer-events:none;white-space:nowrap;box-shadow:0 4px 20px rgba(14,58,39,0.25);';
        document.body.appendChild(toast);
      }
      toast.textContent = msg;
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
      clearTimeout(toast._timer);
      toast._timer = setTimeout(() => {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(-50%) translateY(16px)';
      }, duration);
    };
  }

})();
